import request from '../utils/request'

// 登陆 验证码登陆
export function login(data) {
    return request({
        url: '/api/pc/user/login?user_mobile='+data.user_mobile+"&smscode="+data.smscode+"&login_type="+data.login_type+'&user_password='+data.user_password,
        method: 'get'
    })
}

// 注册
export function listarea(data) {
    return request({
        url: '/api/open/uni/listarea?parent_name='+data.parent_name+"&pageSize="+data.pageSize,
        method: 'get'
    })
}

// 获取验证码
export function sendsms(data){
    return request({
        url: '/api/open/uni/sendsms',
        method: 'post',
        data
    })
}

// 注册
export function register(data){
    return request({
        url: '/api/pc/user/register',
        method: 'post',
        data
    })
}

// 修改密码
export function resetPwd(data){
    return request({
        url: '/api/pc/user/resetPwd',
        method: 'post',
        data
    })
}

// 获取首页的导航
export function listads(data){
    return request({
        url: "/api/open/uni/listads?cate_value="+data.cate_value,
        method: 'get'
    })
}

export function listarticle(data){
    return request({
        url: '/api/open/uni/listarticle?channel='+data.channel+'&pageNum='+data.pageNum+'&pageSize='+data.pageSize,
        method: 'get'
    })
}